<template>
  <main>
    <section class="hero2">
      <v-row
        ><v-spacer></v-spacer>
        <v-col cols="10">
          <v-card
            class="hidden-sm-and-down"
            height="45vw"
            id="landing-img"
            elevation="0"
          ></v-card></v-col
      ></v-row>
      <v-layout>
        <v-row style="height: 45vw; margin: 0vw 6vw" align="center">
          <v-col sm="12" md="4" class="landing-content">
            <div>
              <transition
                name="custom-classes-transition"
                enter-active-class="animated fadeIn"
              >
                <div v-show="showHeroText">
                  <span
                    class="louis--text"
                    style="color: #00857c"
                    :style="headingOneFont"
                  >
                    Innovative Research for a Healthier Future
                  </span>
                  <div class="mt-4">
                    <v-btn
                      color="#00857c"
                      class="white--text"
                      :x-large="$vuetify.breakpoint.mdAndUp"
                      style="
                        text-transform: none;
                        font-family: 'Louis George Café';
                      "
                      elevation="0"
                      to="/join-a-trial"
                      ><v-icon left>mdi-plus</v-icon> Join trial</v-btn
                    >
                  </div>
                </div>
              </transition>
            </div>
          </v-col>
          <!-- <v-col class="hidden-sm-and-down landing-content-back"></v-col> -->
        </v-row>
      </v-layout>
      <v-layout style="z-index: 10; position: relative"
        ><v-row
          style="background: #00857c"
          :style="logoSection"
          align="center"
          justify="space-around"
          ><v-img
            max-width="12%"
            max-height="55%"
            src="@/assets/nova_logo.svg"
          ></v-img
          ><v-img
            max-width="12%"
            max-height="55%"
            src="@/assets/Theia_Clinical_Research_LLC_logo.svg"
          ></v-img
          ><v-img
            max-width="12%"
            max-height="55%"
            src="@/assets/Neuraly_logo.svg"
          ></v-img></v-row
      ></v-layout>
      <v-row align="center"
        ><v-card
          height="20vw"
          max-height="140"
          width="100%"
          class="d-flex justify-center align-end"
          style="margin: 0vw 6vw; margin-bottom: 2vw"
          elevation="0"
          ><v-card-title style="color: #00857c" :style="headingTwoFont"
            >Why should you contribute?</v-card-title
          ></v-card
        ></v-row
      >
      <v-card elevation="0" style="padding-bottom: 140px">
        <div>
          <v-row align="center" justify="center">
            <div
              v-for="(card, idx) in cards"
              :key="idx"
              class="d-flex justify-center align-center"
              style="padding-right: 24px; padding-bottom: 24px"
            >
              <v-card class="pa-6 card-custom-style" :style="cardStyle">
                <v-row style="padding-left: 16px">
                  <v-img :style="cardIcon" :src="card.icon"></v-img>
                  <v-card-title
                    class="text-black"
                    v-text="card.title"
                    :style="headingFourFont"
                  ></v-card-title
                ></v-row>
                <v-row>
                  <v-card-subtitle
                    v-text="card.subTitle"
                    :style="paragraphTwoFont"
                    style="color: black"
                  ></v-card-subtitle>
                </v-row>
              </v-card>
            </div>
          </v-row>
        </div>
      </v-card>
      <v-row
        ><v-card
          height="2vw"
          max-height="120"
          width="100%"
          class="d-flex justify-center align-end"
          style="margin: 0vw 6vw; margin-bottom: 42px"
          elevation="0"
          ><v-card-title style="color: #00857c" :style="headingTwoFont"
            >Discover your ideal trial and pave the way to better
            health.</v-card-title
          ></v-card
        ></v-row
      >
      <div class="d-flex justify-center" style="margin-bottom: 10vw">
        <v-btn
          color="#00857c"
          class="white--text"
          x-large
          style="text-transform: none; font-family: 'Louis George Café'"
          elevation="0"
          to="/join-a-trial"
          ><v-icon left>mdi-plus</v-icon> Join trial</v-btn
        >
      </div>
<!--      <v-row style="margin: 0vw 8vw"-->
<!--        ><v-spacer></v-spacer>-->
<!--        <v-col>-->
<!--          <v-card-->
<!--            width="924px"-->
<!--            class="hidden-sm-and-down"-->
<!--            height="443px"-->
<!--            id="testimonial-section-img"-->
<!--            elevation="0"-->
<!--          ></v-card></v-col-->
<!--      ></v-row>-->
<!--      <v-layout>-->
<!--        <v-row style="margin: 0vw 6vw" align="center">-->
<!--          <v-col sm="12" md="4" class="landing-content">-->
<!--            <div>-->
<!--              <transition-->
<!--                name="custom-classes-transition"-->
<!--                enter-active-class="animated fadeIn"-->
<!--              >-->
<!--                <div v-show="showHeroText">-->
<!--                  <span-->
<!--                    class="louis&#45;&#45;text"-->
<!--                    style="color: #00857c"-->
<!--                    :style="headingThreeFont"-->
<!--                  >-->
<!--                    Testimonials-->
<!--                  </span>-->
<!--                  <div-->
<!--                    :style="`-->
<!--                      position: relative;-->
<!--                      height: 300px;-->
<!--                      width: ${$vuetify.breakpoint.mdAndUp ? '35vw' : '90vw'};-->
<!--                      margin-top: 40px;-->
<!--                    `"-->
<!--                  >-->
<!--                    <div-->
<!--                      style="-->
<!--                        position: absolute;-->
<!--                        bottom: 20px;-->
<!--                        right: 0;-->
<!--                        z-index: 2;-->
<!--                      "-->
<!--                    >-->
<!--                      <v-btn depressed icon @click="slide -= 1" elevation="0"-->
<!--                        ><v-icon right color="#00857C"-->
<!--                          >mdi-arrow-left</v-icon-->
<!--                        ></v-btn-->
<!--                      >-->
<!--                      <v-btn-->
<!--                        depressed-->
<!--                        icon-->
<!--                        class="ml-3"-->
<!--                        @click="slide += 1"-->
<!--                        elevation="0"-->
<!--                        ><v-icon left color="#00857C"-->
<!--                          >mdi-arrow-right</v-icon-->
<!--                        ></v-btn-->
<!--                      >-->
<!--                    </div>-->
<!--                    <v-carousel-->
<!--                      v-model="slide"-->
<!--                      height="100%"-->
<!--                      class="mt-4"-->
<!--                      hide-delimiters-->
<!--                      :show-arrows="false"-->
<!--                    >-->
<!--                      <v-carousel-item-->
<!--                        v-for="(item, i) in testimonials"-->
<!--                        :key="i"-->
<!--                      >-->
<!--                        <div-->
<!--                          class="d-flex justify-center align-start"-->
<!--                          :style="`height: 80%; color: black; ${headingFourFont}`"-->
<!--                        >-->
<!--                          {{ item.text }}-->
<!--                        </div>-->
<!--                        <div-->
<!--                          class="d-flex justify-left align-start"-->
<!--                          :style="`height: 12%; color: #FF7C45; ${headingFourFont}`"-->
<!--                        >-->
<!--                          {{ item.consultant_name }}-->
<!--                        </div>-->
<!--                        <div-->
<!--                          class="d-flex justify-left align-start"-->
<!--                          :style="`height: 8%; color: black; ${paragraphTwoFont}`"-->
<!--                        >-->
<!--                          {{ item.address }}-->
<!--                        </div>-->
<!--                      </v-carousel-item>-->
<!--                    </v-carousel>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </transition>-->
<!--            </div>-->
<!--          </v-col>-->
<!--          &lt;!&ndash; <v-col class="hidden-sm-and-down landing-content-back"></v-col> &ndash;&gt;-->
<!--        </v-row>-->
<!--      </v-layout>-->
      <!-- <div
        class="hidden-sm-and-down container"
        style="z-index: 100; margin-top: 15%"
      >
        <div
          style="
            position: absolute;
            margin-bottom: 20%;
            font-size: 44px;
            text-align: center;
            width: 1400px;
            z-index: 200;
          "
          class="hidden-sm-and-down"
        >
          Our mission is to use our expertise to make finding clinical research
          trials near you accessible and easy to understand, furthering the
          advancement of healthcare.
        </div>
        <svg
          width="1400"
          height="192"
          viewBox="0 0 1440 192"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 70.0702V104.17C0 104.17 312 301.056 720 104.17C1128 -92.7174 1440 128.4 1440 128.4V97.2985C1440 97.2985 1111.88 -111.797 759.375 83.059C406.875 277.915 0 70.0702 0 70.0702Z"
            fill="url(#paint0_linear)"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="3.0126e-06"
              y1="95.5077"
              x2="1440"
              y2="95.5077"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#89DCFF" />
              <stop offset="0.494792" stop-color="#CEC2BD" stop-opacity="0.5" />
              <stop offset="0.84375" stop-color="#FFAF8E" />
            </linearGradient>
          </defs>
        </svg>
      </div> -->

      <!--      Landing with image slides-->
      <!--<v-carousel
        cycle
        height="calc(100vh - 80px)"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        show-arrows-on-hover
      >
        <v-carousel-item
          v-for="(slide, i) in adSlides"
          :key="i"
          gradient="0deg, rgba(0, 0, 0, 0.4) 32.29%, rgba(54, 54, 54, 0) 100% "
          :lazy-src="slide.image"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-container class="wide-container h-100">
            <v-row class="h-100 " align="end">
              <v-col sm="12" md="8" class="mb-12">
                <v-row align="center" class="h-100">
                  <div>
                    <transition
                      name="custom-classes-transition"
                      enter-active-class="animated fadeIn"
                    >
                      <div v-show="showHeroText">
                        <h1 class="mb-5 hero__heading livvic&#45;&#45;text">
                          {{ slide.title }}
                        </h1>
                        <p class="hero__subheading mb-3 mt-3">
                          {{ slide.subtitle }}
                        </p>
                      </div>
                    </transition>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-carousel-item>
      </v-carousel>-->

      <!--      Landing with background image-->
      <!--<v-container class="wide-container h-100">
        <v-row class="h-100 " align="end">
          <v-col sm="12" md="7" class="mb-7">
            <v-row align="center" class="h-100">
              <div>
                <transition
                  name="custom-classes-transition"
                  enter-active-class="animated fadeIn"
                >
                  <div v-show="showHeroText">
                    <h1 class="mb-5 hero__heading livvic&#45;&#45;text">
                      Find Clinical Trials Near You
                    </h1>
                    <p class="hero__subheading mb-3 mt-3">
                      Patient recruitment service for clinical trials using
                      digital marketing strategies.
                    </p>
                  </div>
                </transition>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>-->
    </section>
    <section>
      <v-container> </v-container>
    </section>
  </main>
</template>

<script>
// import feature1 from "@/assets/ad-features/feature1.png";
// import feature2 from "@/assets/ad-features/feature2.png";
// import feature3 from "@/assets/ad-features/feature3.png";
// import feature4 from "@/assets/ad-features/feature4.png";
// import landing_img1 from "@/assets/landing_img2.jpg";
// import landing_img2 from "@/assets/landing_img.png";
// import landing_img3 from "@/assets/landing_img3.jpg";
// import landing_img4 from "@/assets/landing_img4.jpg";
// import landing_img5 from "@/assets/landing_img5.jpg";
// import landing_img6 from "@/assets/landing_img6.jpg";
// const adSlides = [
//   {
//     title: "Patient recruitment service for clinical trials",
//     subtitle:
//       "Targeted advertisement for a clinical trial on specific geolocation",
//     image: landing_img1
//   },
//   {
//     title: "Patient recruitment service for clinical trials",
//     subtitle: "Refinement of advertisements based on trial criteria",
//     image: landing_img2
//   },
//   {
//     title: "Patient recruitment service for clinical trials",
//     subtitle:
//       "Patient recruitment from various social media platforms and the web",
//     image: landing_img3
//   },
//   {
//     title: "Patient recruitment service for clinical trials",
//     subtitle: "Pre-Screening Service",
//     image: landing_img4
//   },
//   {
//     title: "Patient recruitment service for clinical trials",
//     subtitle: "Advertisement Design Service",
//     image: landing_img5
//   },
//   {
//     title: "Patient recruitment service for clinical trials",
//     subtitle: "Patient Retention Service",
//     image: landing_img6
//   }
// ];
// const adFeatures = [
//   {
//     title: "Broadcast Targeted Advertisement",
//     subtitle:
//       "We broadcast targeted advertisement to potential patients nearby a trial site. Advertisements are provided on various social media platforms , google adsense, Bing and Yahoo. We refine recipients using geolocation and study criteria.",
//     image: feature1
//   },
//   {
//     title: "IRB Approved Advertise",
//     subtitle:
//       "Once a potential participant clicks on the advertise, s/he is redirected to the listing page of the study. IRB approved advertise provided to the patient with an option to sign up for the study.",
//     image: feature2
//   },
//   {
//     title: "Enrolling the Clients",
//     subtitle:
//       "After sign up, contact information is emailed to the site and the pre-screening call center. Our trained call center agent pre-screen a patient based on study criteria and enroll the person into the trial.",
//     image: feature3
//   },
//   {
//     title: "Client Info According to Geolocation",
//     subtitle:
//       "With the consent of a patient we create a detailed profile. Information is stored for the patient retention service in other studies on nearby geolocation.",
//     image: feature4
//   }
// ];
export default {
  name: "AdHome",
  components: {
    // AdFeature
  },
  metaInfo: {
    title: "Zeda - Home",
    meta: [
      { charset: "utf-8" },
      { name: "description", content: "This is the homepage for Zeda." },
    ],
  },
  created() {
    if (this.$route.meta.previousRoute.name === "trial_details") {
      this.$store.commit(
        "set_trial_details_route_from",
        this.$route.meta.previousRoute.path
      );
    }
  },
  data() {
    return {
      slide: 0,
      // testimonials: [
      //   {
      //     text: "“ Zeda.ai is a game-changer. It connects patients to cutting-edge research effortlessly. As a doctor, I've found tailored trials, providing innovative treatments and advancing medicine. It's a must-have resource that empowers patients and accelerates progress. I wholeheartedly endorse Zeda.”",
      //     consultant_name: "Dr. Jessica Reynolds, MD",
      //     address: "Lakeside General Hospital, Qubec",
      //   },
      // ],
      showHeroText: true,
      snackbar: false,
      cards: [
        {
          title: "Access to Innovative Treatments",
          subTitle:
            "Clinical trials offer the chance to receive new, potentially more effective treatments that are not yet available to the general public. By participating, individuals gain access to the latest advancements in medical care.",
          icon: require("@/assets/card_icon_1.svg"),
        },
        {
          title: "Contribution to Medical Science",
          subTitle:
            "By participating in clinical trials, you actively fuel groundbreaking research, shaping innovative treatments, and advancing healthcare outcomes, making a significant impact on the lives of individuals worldwide.",
          icon: require("@/assets/card_icon_2.svg"),
        },
        {
          title: "Personal Health Benefits",
          subTitle:
            "Participants will receive comprehensive medical evaluations, including regular check-ups, laboratory tests, and screenings. These evaluations can provide valuable insights into their overall health and well-being.",
          icon: require("@/assets/card_icon_3.svg"),
        },
        {
          title: "Helping the future",
          subTitle:
            "Contribute to better healthcare for future generations. Your involvement directly impacts the development of new therapies, benefiting countless individuals facing similar health challenges in the process",
          icon: require("@/assets/card_icon_4.svg"),
        },
        {
          title: "Potential Financial Benefits",
          subTitle:
            "Some clinical trials provide compensation for participants' time and travel expenses, offering a practical incentive for those who may need financial support.",
          icon: require("@/assets/card_icon_5.svg"),
        },
        {
          title: "Opportunity for Early Access",
          subTitle:
            "In certain cases, clinical trials offer the chance to access promising treatments before they become widely available. This early access can be especially valuable for individuals with limited treatment options.",
          icon: require("@/assets/card_icon_6.svg"),
        },
      ],
    };
  },
  computed: {
    cardIcon() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "max-height: 24px; max-width: 32px; align-self: center;"; // Extra small screens (less than 600px)
        case "sm":
          return "height: 30px; max-width: 40px; align-self: center;"; // Small screens (600px and up)
        case "md":
          return "height: 36px; max-width: 44px; align-self: center;"; // Medium screens (960px and up)
        case "lg":
          return "height: 48px; max-width: 65px; align-self: center;"; // Large screens (1264px and up)
        case "xl":
          return "height: 52px; max-width: 71px; align-self: center;"; // Extra large screens (1904px and up)
        default:
          return "height: 52px; max-width: 71px; align-self: center;";
      }
    },
    logoSection() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "height: 40px"; // Extra small screens (less than 600px)
        case "sm":
          return "height: 80px"; // Small screens (600px and up)
        case "md":
          return "height: 110px"; // Medium screens (960px and up)
        case "lg":
          return "height: 144px"; // Large screens (1264px and up)
        case "xl":
          return "height: 144px"; // Extra large screens (1904px and up)
        default:
          return "height: 144px";
      }
    },

    cardStyle() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "width: 356px; height: 180px"; // Extra small screens (less than 600px)
        case "sm":
          return "width: 564px; height: 180px"; // Small screens (600px and up)
        case "md":
          return "width: 428px; height: 180px"; // Medium screens (960px and up)
        case "lg":
          return "width: 536px; height: 224px"; // Large screens (1264px and up)
        case "xl":
          return "width: 536px; height: 224px"; // Extra large screens (1904px and up)
        default:
          return "width: 536px; height: 224px";
      }
    },

    headingOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 28px; line-height: 42px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 36px; line-height: 46px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 40px; line-height: 50px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 44px; line-height: 54px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 48px; line-height: 58px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 48px; line-height: 58px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    headingTwoFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 22px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 28px; line-height: 36px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 36px; line-height: 44px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 40px; line-height: 48px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 40px; line-height: 48px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    headingThreeFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 32px; line-height: 40px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    headingFourFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 16px; line-height: 20px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 24px; line-height: 28px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    paragraphTwoFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 16px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 16px; line-height: 25px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 16px; line-height: 25px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 16px; line-height: 25px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_colors.scss";
section {
  margin-bottom: 50px;
}

.card-custom-style {
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2),
    7px 0px 48px rgba(42, 77, 66, 0.03) !important;
  border-radius: 5px !important;
}

#landing-img {
  display: inline-block;
  margin: auto;
  background-image: url("~@/assets/landing_page.png");
  background-position: top right;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 70%;
}

#testimonial-section-img {
  display: inline-block;
  margin: auto;
  background-image: url("~@/assets/testimonial_section.svg");
  background-position: top right;
  background-size: contain;
  position: absolute;
  width: 100%;
  height: 443px;
}

.hero2 {
  height: calc(40%);
  background-color: white;

  .landing-content {
    background-color: white;
    z-index: 2;
  }

  .landing-content-back {
    position: absolute;
    top: 0px;
    width: 540px;
    min-height: 71%;
    background-color: white;
    transform: skewX(-10deg);
    z-index: 1;
  }
  .hero__subheading {
    font-size: 1.9em;
    font-family: "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    color: #5b5c5e;

    @media (max-width: 1960px) {
      font-size: 1.6em;
    }
  }
  .hero__heading {
    font-size: 3.2em;
    color: #3a3a3a;
    line-height: 1.2;
    font-weight: bold;

    @media (max-width: 600px) {
      font-size: 2.9em;
    }
  }
}
.hero {
  height: 90vh;
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.4) 32.29%,
      rgba(54, 54, 54, 0) 100%
    ),
    url("~@/assets/landing_img2.jpg") !important;
  background-size: cover;
  background-color: #ffff;
}
//.hero__subheading {
//  font-size: 1.5em;
//  font-family: "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
//  color: #ffff;
//
//  @media (max-width: 960px) {
//    font-size: 1.2em;
//  }
//}
//.hero__heading {
//  font-size: 3.8em;
//  color: #ffff;
//  line-height: 1.2;
//  font-weight: bold;
//
//  @media (max-width: 600px) {
//    font-size: 2.5em;
//  }
//}
.section__heading {
  font-size: 3em;
  color: #3a3a3a;
  line-height: 1.2;
  font-weight: bold;

  @media (max-width: 600px) {
    font-size: 2em;
  }
}
// .wide-container {
//   max-width: 1100px !important;
// }
.process {
  background-color: #fff;
  .section-title {
    font-size: 2.5em;
    color: #3a3a3a;
    line-height: 1.2;
    font-weight: bold;
  }
  .section-subtitle {
    font-size: 1.3em;
    color: #5b5c5e;
    margin-top: 40px;
  }

  .feature-list {
    list-style-type: none;
    margin-top: 30px;
  }
  .feature-list-item {
    border-left: 4px solid #77838f;
    padding: 5px 0 2px 20px;
    margin-bottom: 20px;
    opacity: 0.6;
  }
  .feature-list-item--selected {
    border-left: 4px solid #0099dc;
    opacity: 1;
  }
}

.cta {
  height: 70vh;
  background-color: #f5f4ff;

  h1 {
    @media (max-width: 900px) {
      text-align: center;
      font-size: 2.5em !important;
    }
  }
}
.m-home-page {
  margin-top: 80px;
}
</style>
